import {
    click_origin_breach_screen,
    ConfigurationContext,
    EntitledToView,
} from '@news-mono/web-common'
import React, { useContext } from 'react'
import { useAuthActions } from '../..'
import {
    StyledContainer,
    StyledEntitledText,
    StyledOpportunityText,
    StyledButton,
    StyledWestMark,
    StyledHeaderText,
    StyledSubText,
    StyledSlimWestMark,
    StyledWatchNowText,
} from './TWStaticVCSubscribeCard.styled'
import { TheWestMark } from '../../logos/TheWestMark/TheWestMark'
import { colors } from '../../__styling/settings/colors'

interface CardOptions {
    options?: {
        btnOptions?: SubscriberButtonProps
    }
}

interface SubscriberButtonProps {
    link: string
    offerCode: string
}

export const EntitledView = () => {
    return (
        <StyledContainer>
            <StyledWestMark>
                <TheWestMark fill={colors.white} height={35} width={43} />
            </StyledWestMark>
            <StyledEntitledText>
                Discover
                More
                <b>Homegrown</b>
                Series
            </StyledEntitledText>
            <StyledButton
                onClick={() => {}}
                to={'#other-exclusive-series'}
            >
                Watch Now
            </StyledButton>
        </StyledContainer>
    )
}
export const OpportunityView: React.FC<CardOptions> = ({ options }) => {
    const { onSubscribeClick } = useAuthActions()
    const config = useContext(ConfigurationContext)

    const { btnOptions } = options || {}
    const subscribeUrl = (config.subscribeTheWestUrl || 'https://subscriber.thewest.com.au') + '/'
    const subscribeUtm = btnOptions?.link
    const hasBikiePromo = false
    const subscribeLink = subscribeUrl + subscribeUtm

    function buttonClickHandler(e: React.MouseEvent<HTMLElement>) {
        if (!(btnOptions?.link && hasBikiePromo)) return
        e.preventDefault()
        onSubscribeClick({
            packagePath: subscribeUtm,
            offerCode: btnOptions.offerCode,
            callToAction: click_origin_breach_screen,
        })
    }

    return (
        <StyledContainer>
            <StyledSlimWestMark>
                <TheWestMark fill={colors.white} height={35} width={43} />
            </StyledSlimWestMark>
            <StyledHeaderText>
                40% OFF
            </StyledHeaderText>
            <StyledSubText>
                a digital subscription
            </StyledSubText>
            <StyledOpportunityText>
                Discover More<br />
                <b>Homegrown</b> Series
            </StyledOpportunityText>
            <StyledButton
                onClick={buttonClickHandler}
                to={subscribeLink}
            >
                Subscribe to Watch
            </StyledButton>
        </StyledContainer>
    )
}

export const TWStaticVCSubscribeCard: React.FC<CardOptions> = ({ options }) => {
    return (
        <EntitledToView
            requiredAccess={{ level: 'subscriber' }}
            entitled={() => {
                return <EntitledView />
            }}
            notEntitled={() => {
                return <OpportunityView options={options} />
            }}
        />
    )
}
